<template>
	<!-- <link rel='stylesheet' href='http://kefu.yilongshanghui.com/assets/css/index/cgwl_online.css'> -->
 <!-- <div class="CustomerList">
    <div
      class="item acea-row row-between-wrapper"
      v-for="item in list"
      :key="item.id"
      @click="$router.push('/customer/chat/' + item.uid)"
    >
      <div class="pictrue"><img :src="item.avatar" /></div>
      <div class="text line1">{{ item.nickname }}</div>
    </div>
  </div> -->
  <div>
	 <div class="cgwl-form" id="cgwl-kefu" > 
	   <i class="cgwl-icon"></i>
	   <form class="cgwl-item" action="http://kefu.yilongshanghui.com/index/index/home?visiter_id=&visiter_name=&avatar=&business_id=1&groupid=0" method="post" target="_blank" >
	   <input type="hidden" name="product" value=''>
	   <input type="submit" value='在线咨询' style="width: 100%;text-align: center; margin-top: 20px;">
	   </form>
	 </div> 
	  
  </div>
  
</template> 
<script>
import { serviceList } from "@api/user";

export default {
  name: "CustomerList",
  data() {
    return {
      list: []
    };
  },
  methods: {
    getList() {
     var _hmt = _hmt || [];
     (function() {
     	var hm = document.createElement("script");
     	hm.src = "https://hm.baidu.com/hm.js?18acc9c206c73ec1fad3e23b4220cf1b";
     	var s = document.getElementsByTagName("script")[0];
     	s.parentNode.insertBefore(hm, s);
		console.log('123')
     })();
	 
	 console.log("123123")
    }
  },
  mounted() {
    this.getList();
  }
};
 </script>
<style scoped>
.CustomerList {
  margin-top: 0.13rem;
}
.CustomerList .item {
  height: 1.38rem;
  border-bottom: 1px solid #eee;
  padding: 0 0.24rem;
  background-color: #fff;
}
.CustomerList .item .pictrue {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 50%;
  border: 0.03rem solid #fff;
  box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -webkit-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
  -moz-box-shadow: 0 0 0.1rem 0.05rem #f3f3f3;
}
.CustomerList .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.CustomerList .item .text {
  width: 5.82rem;
  font-size: 0.32rem;
  color: #000;
}
</style>
